<app-header [isSidebarOpen]="isSidebarOpen" [hasSidebar]="true"
  (actionClicked)="handleHeaderAction($event)" (toggleSupport)="isSupportOpen = true"></app-header>

<div class="main-content-wrapper-body">
  <app-sidebar [isOpen]="isSidebarOpen" [navItems]="navItems" (sidebarToggle)="onSidebarToggle($event)">
  </app-sidebar>

  <div class="main-content" [class.sidebar-open]="isSidebarOpen">
    <router-outlet *ngIf="!isProducerFlowCheckInProgress && canRenderProtectedContent"></router-outlet>
    <div class="content-gate-placeholder" *ngIf="isProducerFlowCheckInProgress || !canRenderProtectedContent"></div>
  </div>

  <footer [class.sidebar-open]="isSidebarOpen">
    <div class="copyright">
      Green Shield Compass - Powered By BluePond.AI ({{ currentYear }})
    </div>
  </footer>
</div>
<div class="support-scope">
  <lib-support
    [isOpen]="isSupportOpen"
    (closePanel)="isSupportOpen = false"
    [appId]="appId"
    panelTitle="Compass Support"
  ></lib-support>
</div>